<template>
	<div class="sign">
		<div class="header bg-color-red" v-if="show == 1">
			<div class="headerCon acea-row row-between-wrapper">
				<div class="box">
					<div>{{ month }}月已领取：{{receive_num}}颗</div>
					<div>总计已领取：{{all_receive_num}}颗</div>
				</div>
				<div class="ege">
					<img src="../../../assets/images/ege.png" />
				</div>
			</div>
			<!-- <div class="btn">
				<div class="text" :class="userInfo.is_day_sgin ? 'on' : ''" @click="goSign">{{ userInfo.is_day_sgin ? "已签到" : "立即签到" }}</div>
				<div>{{ userInfo.is_day_sgin ? "" : "您今日还未签到哦~" }}</div>
			</div> -->
		</div>
		<div class="header bg-color-red"  style="height: 1.5rem;">
		</div>
		<div class="wrapper" v-if="show != 1">
			<div class="list acea-row row-between-wrapper">
				<div class="item" v-for="(item, index) in signSystemList" :key="index">
					<div :class="index + 1 === signSystemList.length ? 'rewardTxt' : ''">{{ item.day }}</div>
					<div class="venus" :class="(index + 1 === signSystemList.length ? 'reward' : '') +' ' +(sign_index >= index + 1 ? 'venusSelect' : '')"></div>
					<div class="num" :class="sign_index >= index + 1 ? 'on' : ''">
						+{{ item.sign_num }}
					</div>
				</div>
			</div>
			<!--加在 but 上 on 为已签到-->
			<div class="but bg-color-red" :class="userInfo.is_day_sgin ? 'on' : ''" @click="goSign">
				{{ userInfo.is_day_sgin ? "已签到" : "立即签到" }}
			</div>
			<div class="lock"></div>
		</div>
		<div class="wrapper" v-if="show == 1">
			<div class="list acea-row row-between-wrapper mainBox">
				<Calendar :textTop="['日', '一', '二', '三', '四', '五', '六']" :markDate="arr" :sundayStart="true" futureDayHide="0">
				</Calendar>
			</div>
			<!-- <div class="but bg-color-red" :class="userInfo.is_day_sgin ? 'on' : ''" @click="goSign">
				{{ userInfo.is_day_sgin ? "已签到" : "立即签到" }}
			</div> -->
			<div class="lock"></div>
		</div>
		<div class="wrapper wrapper2">
			<div class="tip">已累计签到</div>
			<div class="list2 acea-row row-center row-bottom">
				<div class="item" v-for="(item, index) in signCount" :key="index">
					{{ item || 0 }}
				</div>
				<div class="data">天</div>
			</div>
			<div class="tip2" v-if="show == 1 && userInfo.sum_sgin_day" style="margin-bottom:20px">
				~当前可领取<span style="color:#5DAB0C">{{no_receive}}</span>颗鸡蛋~
			</div>
			<div class="tip2">
				据说连续签到第{{ day }}天可获得超额积分，一定要坚持签到哦~~~
			</div>
			<div class="sign" v-if="show == 1" style="width:85%;margin:0 auto;padding:20px 0;border-top:1px solid #c7c7c7">
				<div class="btn">
					<div class="text" style="width:2.5rem;background:#83C23D;" @click="getReceive">到店领鸡蛋</div>
				</div>
				<div style="color:red">注意：{{userInfo.actrq}}请本人到店领取鸡蛋后收银员点击按钮，本人点击则作废</div>
				<div style="text-align: center;margin:10px 0">
					<img src="../../../assets/images/address2.png" style="width:0.5rem;vertical-align: bottom;margin-right:10px"/>门店位置：{{userInfo.actaddress}}
				</div>
			</div>
			<div class="list3">
				<div class="item acea-row row-between-wrapper" v-for="(item, index) in signList" :key="index">
					<div>
						<div class="name line1">{{ item.title }}</div>
						<div class="data">{{ item.add_time }}</div>
					</div>
					<div class="num font-color-red">+{{ item.number }}</div>
				</div>
				<router-link :to="'/user/sign_record'" class="Loads acea-row row-center-wrapper" v-if="signList.length > 0">
					点击加载更多
					<div class="iconfont icon-xiangyou acea-row row-center-wrapper"></div>
				</router-link>
			</div>
		</div>
		<div class="signTip acea-row row-center-wrapper" :class="active === true ? 'on' : ''">
			<div class="signTipLight loadingpic"></div>
			<div class="signTipCon">
				<div class="state">{{qd_title}}</div>
				<!-- <div class="integral" v-if="show == 1">{{qd_text}}</div> -->
				<div class="integral">获得{{ integral }}积分</div>
				<div class="signTipBnt" @click="close">好的</div>
			</div>
		</div>
		<div class="mask" @touchmove.prevent :hidden="active === false"></div>
		<div class="modal-zz" v-show="modelshow==1">
			<div class="modal">
				<div class="modal-body">
					<p style="color:red">特别提醒：</p>
					<p style="color:red">到指定实体店兑换鸡蛋,领取按钮仅店长方可操作，本人点击作废。</p>

				</div>
				<div class="modal-footer">
					<div @click="qx">取消</div>
					<div style="width:1px;background:#c7c7c7"></div>
					<div style="background: rgb(131, 194, 61);color:#fff" @click="lq">领取</div>
				</div>
			</div>
		</div>
	</div>
	
</template>
<script>
	import {
		postSignUser,
		getSignConfig,
		postSignIntegral,
		getSignList,
		ReceiveEge
	} from "@api/user";
	import {
		add
	} from "@utils/bc";
	import Calendar from "vue-calendar-component";

	export default {
		name: "Sign",
		components: {
			Calendar
		},
		props: {},
		data: function() {
			return {
				userInfo: {},
				integral: 0,
				signCount: [],
				sign_index: 0,
				signSystemList: [],
				signList: [],
				page: 1,
				limit: 3,
				active: false,
				day: "",
				show: 0,
				arr: [],
				// arr: ["2020.11.3","2020.12.3", "2020.12.13", "2020.12.25", "2020.12.8"],
				month: "",
				receive_num: 0,
				all_receive_num: 0,
				qd_title: "签到成功",
				qd_text: "",
				no_receive: "",
				modelshow:0,
			};
		},
		watch: {
			$route(n) {
				this.signUser();
				this.signConfig();
				this.getSignList();
			}
		},
		mounted: function() {
			this.signUser();
			this.signConfig();
			this.getSignList();
		},
		methods: {
			lq:function(){
				let that = this
				this.modelshow=0;
				ReceiveEge().then(res => {
					this.signUser();
					that.qd_title = "领取成功";
					that.qd_text = res.msg;
					that.active = true;
				}, error => {
					that.qd_title = "领取失败"
					that.qd_text = error.msg
					that.active = true;
					that.signUser();
					that.getSignList();
				})
			},
			qx:function(){
				this.modelshow=0;
			},
			// js给数字补0；num：需要补0的数字，length：长度（补到多少位）；
			PrefixInteger: function(num, length) {
				return (Array(length).join("0") + num).slice(-length).split("");
			},
			//数字转中文
			Rp: function(n) {
				var cnum = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
				var s = "";
				n = "" + n; // 数字转为字符串
				for (var i = 0; i < n.length; i++) {
					s += cnum[parseInt(n.charAt(i))];
				}
				return s;
			},
			// 获取用户信息
			signUser: function() {
				let that = this;
				postSignUser({
					sign: 1
				}).then(res => {
					if (res.data.receive_num) {
						that.receive_num = res.data.receive_num;
					}
					if (res.data.all_receive_num) {
						that.all_receive_num = res.data.all_receive_num;
					}
					if (that.show = 1) {
						if (!that.qd_text) {
							that.qd_text = "获得待领取鸡蛋" + parseInt(res.data.integral) + "颗";
						}
					}
					res.data.integral = parseInt(res.data.integral);
					var sumSginDay = res.data.sum_sgin_day;
					that.no_receive = res.data.no_receive;
					that.userInfo = res.data;
					that.show = res.data.show;
					that.month = res.data.month;
					that.signCount = that.PrefixInteger(sumSginDay, 4);
					that.sign_index = parseInt(res.data.sign_num);
				});
			},
			// 签到配置
			signConfig: function() {
				let that = this;
				getSignConfig().then(res => {
					that.signSystemList = res.data;
					that.day = that.Rp(that.signSystemList.length);
				});
			},
			//  用户签到
			goSign: function() {
				let that = this,
					sumSginDay = that.userInfo.sum_sgin_day;
				if (that.userInfo.is_day_sgin)
					return that.$dialog.toast({
						mes: "您今日已签到!"
					});
				postSignIntegral().then(res => {
					if (that.show = 1) {
						that.qd_text = res.msg;
					}
					console.log(that.qd_text)
					that.active = true;
					that.integral = res.data.integral;
					let sign_index = parseInt(that.sign_index + 1);
					that.sign_index = sign_index > that.signSystemList.length ? 1 : sign_index;
					that.signCount = that.PrefixInteger(sumSginDay + 1, 4);
					that.userInfo.is_day_sgin = true;
					that.userInfo.integral = add(that.userInfo.integral, res.data.integral);
					that.signUser();
					// that.getSignList();
				});
			},
			//  获取签到列表;
			getSignList: function() {
				let that = this;
				getSignList(that.page, that.limit).then(res => {
					if (res.data.level > 0) {
						that.arr = res.data.signList
					} else {
						that.signList = res.data.signList;
					}
				});
			},
			close: function() {
				this.active = false;
			},
			getReceive: function() {
				this.modelshow=1;
			}
		}
	};
</script>
<style lang="scss">
	.modal-zz {
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		background-color: rgba(0, 0, 0, .3);
		display: flex;
		justify-content: center;
		align-items: center;
		z-index:50;
	}

	.modal {
		background-color: #fff;
		box-shadow: 2px 2px 20px 1px;
		overflow-x: auto;
		display: flex;
		flex-direction: column;
		border-radius: 16px;
		width: 60%;
	}

	.modal-footer {
		border-top: 1px solid #c7c7c7;
		justify-content: flex-end;
		display: flex;
		justify-content:  space-between;
	}
	.modal-footer div{
		width:50%;
		text-align:center;
		padding:0.2rem 0;
	}
	.modal-body {
		position: relative;
		padding: 20px 10px;
	}




	.sign .header {
		height: 4.5rem;
	}

	.sign .btn div {
		text-align: center;
		color: #fff;
	}

	.mainBox .wh_content_all {
		background: #fff !important;
	}

	.sign .btn .text {
		width: 2rem;
		margin: 0 auto 0.4em;
		padding: 0.4em;
		background: #F3C52A;
		border-radius: 1em;
	}

	.sign .header .headerCon {
		padding: 0 0.3rem;
		box-sizing: border-box;
	}

	.box {
		display: flex;
		justify-content: space-between;
		width: 100%;
		color: #fff;
	}

	.ege {
		width: 15%;
		margin: 0 auto;
	}

	.ege img {
		width: 100%;
		height: 100%;
	}

	.cjtext {
		width: 15%;
		height: 0.4rem;
		background: blue;
		margin: 0 auto;
	}

	.Loads .iconfont {
		font-size: 0.25rem;
		margin: 0.02rem 0 0 0.1rem;
	}

	.wh_jiantou1 {
		border-top: 3px solid #6eb01e !important;
		border-left: 3px solid #6eb01e !important;
	}

	.wh_jiantou2 {
		border-top: 3px solid #6eb01e !important;
		border-right: 3px solid #6eb01e !important;
	}

	.wh_content_li {
		font-weight: bold;
	}

	.mainBox {
		width: 100%;
		width: 100%;

		.wh_content_all {
			background-color: #fff;

			.wh_top_changge li {
				color: #6eb01e;
			}

			.wh_content_item {
				color: #000;
				width: 14%;
				height: 35px;

				.wh_item_date {
					color: #000;
					width: 30px;
					height: 30px;
				}

				.wh_other_dayhide {
					color: #bfbfbf;
				}

				.wh_chose_day {
					background: #d1ff19;
					color: #0d0b0b;
				}

				.wh_isToday {
					background: #ff0!important;
					color: #000!important;
				}
			}
		}
	}

	.wh_content_item>.wh_isMark {
		background: #71b325 !important;
		color: #fff !important;
	}

	.sign .wrapper .list {
		height: auto;
		padding: 0.3rem;
	}
</style>
